export const contactTypeOptions = [
  { ID: 79, Name: 'Operations' },      // 'O'
  { ID: 66, Name: 'Billing' },         // 'B'
  { ID: 83, Name: 'Sales' },           // 'S'
  { ID: 82, Name: 'A/R' },             // 'R'
  { ID: 80, Name: 'A/P' },             // 'P'
  { ID: 69, Name: 'Emergency Only' },  // 'E'
  { ID: 49, Name: 'Primary' },         // '1'
  { ID: 67, Name: 'Corporate' },       // 'C'
  { ID: 68, Name: 'EDI' },             // 'D'
  { ID: 84, Name: 'Tracking' },        // 'T'
  { ID: 65, Name: 'Afterhours' },      // 'A'
  { ID: 42, Name: 'All' }              // '*'
];